import { Button, Modal } from 'antd';
import React, { FC } from 'react';
import styles from './styles.module.css';
import * as translations from '../strings';
import { getLangKey } from 'appJS/models/Language';
import track from '../../../utils/analytics';

type Props = {
  owner: {
    email: string;
    name: string;
    id: number;
  } | null;
  assetIdOrGroup: number | string;
  container: HTMLDivElement;
  project: Object;
  loggedIn: boolean;
  toProjects?: boolean;
  currentUser: Object;
};

const strings = translations[getLangKey()];

const AssetBanner: FC<Props> = ({
  owner,
  assetIdOrGroup,
  project,
  container,
  loggedIn,
  toProjects,
  currentUser
}) => {
  const assetParameter =
    typeof assetIdOrGroup === 'string'
      ? `show_group?group_name=${assetIdOrGroup}`
      : assetIdOrGroup;

  if (loggedIn) {
    track('Existing member has no access to design asset', {
      organization: project?.organizationId,
      project: project?.id,
      user: currentUser?.id
    });
  }

  return (
    <Modal
      open
      footer={null}
      title={null}
      closable={false}
      width="90%"
      className={styles.modal}
      getContainer={container}
    >
      <div className={styles.contentInner}>
        <h2 className={styles.header}>
          {loggedIn ? strings.invited : strings.loginHeader}
        </h2>
        {!loggedIn && (
          <Button
            type="primary"
            href={`/users/sign_in?asset_path=/projects/${project.id}/assets/${assetParameter}`}
          >
            {strings.login}
          </Button>
        )}
        <p className={styles.bannerMessage}>
          {loggedIn || !owner ? (
            strings.contactOwner(owner)
          ) : (
            <>
              {strings.noAccount}
              <Button
                type="link"
                href={`mailto:${owner?.email}`}
                className={styles.ownerButton}
              >
                {strings.projectOwner}
              </Button>
            </>
          )}
        </p>
        {toProjects && (
          <a href="/projects">
            <Button type="primary" className={styles.projectsButton}>
              Back to my projects
            </Button>
          </a>
        )}
      </div>
    </Modal>
  );
};

export default AssetBanner;
